import client from "./client";

export function getProducts() {
    const response = client.get("/api/products");
    return response;
}

export function updateProduct(id, data) {
    const response = client.put("/api/products/" + id, data);
    return response;
}

export function getProductFields (id) {
    const response = client.get("/api/products/" + id + "/fields");
    return response;
}

export function getProductByCode (code) {
    const response = client.get("/api/products/" + code);
    return response;
}

export function getProduct (id) {
    const response = client.get("/api/products/" + id);
    return response;
}

export function getProductField (productCode, id) {
    const response = client.get("/api/products/" + productCode + "/fields/" + id);
    return response;
}

export function addProductField(id, data) {
    const response = client.post(`/api/products/${id}/fields`, data);
    return response;
}

export function updateProductField(productCode, id, data) {
    const response = client.put(`/api/products/${productCode}/fields/${id}`, data);
    return response;
}

export function deleteProductField(productCode, id) {
    const response = client.delete(`/api/products/${productCode}/fields/${id}`);
    return response;
}

export function getProductCovers (id) {
    const response = client.get("/api/products/" + id + "/covers");
    return response;
}